import { render, staticRenderFns } from "./DownloadSalesOrderVsCustomerReportPopUp.vue?vue&type=template&id=632194cc&scoped=true&"
import script from "./DownloadSalesOrderVsCustomerReportPopUp.vue?vue&type=script&lang=js&"
export * from "./DownloadSalesOrderVsCustomerReportPopUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632194cc",
  null
  
)

export default component.exports